import auth from './modules/auth';
import queries from './modules/queries';
import issues from './modules/issues';
import applications from './modules/applications';
import sims from './modules/sims';
import news from './modules/news';
import flights from './modules/flights';
import agents from './modules/agents';

export default {
  auth,
  queries,
  issues,
  applications,
  sims,
  news,
  flights,
  agents,
}
